import { createContext, useMemo, useRef, useCallback } from 'react';

type ExportContextProviderType = {
  children: JSX.Element;
};

export type ExportContextType = {
  updateContent: (ref: React.Ref<unknown> | undefined) => void;
  parentComponentRef: React.RefObject<HTMLElement> | null;
};

const defaultState = {
  parentComponentRef: null,
  updateContent: () => {
    return null;
  },
};

export const ExportContext = createContext<ExportContextType>(defaultState);

export const ExportContextProvider = function ({
  children,
}: ExportContextProviderType): JSX.Element {
  const parentComponentRef = useRef(null);

  const updateContent = useCallback((ref) => {
    parentComponentRef.current = ref.current;
  }, []);

  const values = useMemo(() => {
    return { parentComponentRef, updateContent };
  }, [updateContent]);

  return <ExportContext.Provider value={values}>{children}</ExportContext.Provider>;
};
